import React, {Component} from 'react';
import ReCAPTCHA from "react-google-recaptcha";

/* Import Components */
import Topic from '../components/Topic';
import CheckBox from '../components/CheckBox';
import Input from '../components/Input';
// import TextArea from '../components/TextArea';
import Select from '../components/Select';
import Button from '../components/Button';
import TelephonNumber from '../components/TelephonNumber';
import CheckList from '../components/CheckList';
import InputList from '../components/InputList';
import SelectList from '../components/SelectList';
import RadioList from '../components/RadioList';

const recaptchaRef = React.createRef();

const YearsList = () => {
  let year = new Date().getFullYear() - 18;
  return Array.from(new Array(100),(_, index) => year - index);
}

const MonthList = () => Array.from(Array(12), (_, i) => i + 1);

const DayList = () => Array.from(Array(31), (_, i) => i + 1);

const timeOptions = ['選択してください', '3ヵ月以内', '6ヵ月以内', '1年以内', '1年以上先', '良い物件が見つかり次第'];
const costOptions = ['選択してください', '2000万円未満', '～2300万円', '～2600万円','～2900万円', '～3200万円', '～3500万円', '～3800万円', '～4100万円', '～4400万円', '～4700万円', '～5000万円', '～5300万円', '～5600万円', '5600万円以上'];
const planOptions = ['選択してください', '1LDK', '2LDK', '3LDK', '4LDK', '5LDK以上'];
const contactOptions = ['選択してください', '自宅','携帯','勤務先','その他'];
const typeOptions = ['選択してください', '一戸建て（借家）', '一戸建て（持家）', '賃貸マンション', '分譲マンション', '賃貸アパート', '社宅・官舎', '公社・公団', '親族同居'];
const reasonOptions = ['選択してください', '結婚・独立', '子供部屋が欲しい', '現在の住居が古い', '現在の住居が狭い', '家賃がもったいない', '通勤・通学に不便', '住環境が悪い', '日当たりが悪い', '投資用', '家族・親族用'];
const parkingOptions = ['1台', '2台', '3台', '以上', '必要なし'];
const areaOptions = ['選択してください', '北海道', '青森県',  '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県',
  '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
  '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県',
  '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
];

class FormContainer extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      display: 'questions', // 'checlist' 'finish'
      isVerified: false,
      newUser: {
        name_kanji: {s_kanji: '', n_kanji: ''},
        name_kana:  {s_kana: '', n_kana: ''},
        birthday: {
          0: '',
          1: '',
          2: ''
        },
        zip: '',
        addres: {
          address0: "東京都",
			    address1: "台東区",
          address2: '町名番地',
          address3: '建物名・号室'
        },
        contact: '',
        tel: '',
        mail: '',
        html_mail: false,
        sex: '選択してください',
        area_0: '',
        area_1: '',
        area_2: '',
        current_type: '選択してください',
        reason: '選択してください',
        members: '', //>0
        parking: '',
        time_limit: '選択してください',
        cost: '選択してください',
        floor_plan: '選択してください'
      },

      birthdayOptions: [ YearsList(), MonthList(), DayList()]
    }
    this.handleFormCheck = this.handleFormCheck.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.backToForm = this.backToForm.bind(this);
    this.handleInputList = this.handleInputList.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleCheckBox = this.handleCheckBox.bind(this);
    this.handleAdressByZip = this.handleAdressByZip.bind(this);
    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);

    console.log(this.state);
  }

  //
  handleInputList(event) {    
    let value = event.target.value;
    let name = event.target.name;
    let subname = event.target.id;
    let preventItem = this.state.newUser[name];
    preventItem[subname] = value;

    this.setState(
      prevState => ({
        newUser: {
          ...prevState.newUser,
          [name]: preventItem
        }
      }),
      () => console.log(this.state.newUser)
    );
  }

  //
  handleAdressByZip(event) {
    let value = event.target.value;
    let name = event.target.name;
    value = value.replace(/\D+/g, "");
    console.log(value);

    // if(event.target.value.length === 7) {
    //   let url = 'https://zipcloud.ibsnet.co.jp/api/search?zipcode=1100001';
    //   fetch(url, {
    //     method: 'GET',
    //     mode: 'cors', // no-cors, *cors, same-origin
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     referrerPolicy: 'no-referrer', // no-referrer, *client
    //     // body data type must match "Content-Type" header
    //   })
    //   .then((data) => {
    //     console.log(data); // JSON data parsed by `response.json()` call
    //   });
    // }

    this.setState(
      prevState => ({
        newUser: {
          ...prevState.newUser,
          [name]: value
        }
      }),
      () => console.log(this.state.newUser)
    );
  }

  //
  handleInput(event) {
    let value = event.target.value;
    let name = event.target.name;
    this.setState(
      prevState => ({
        newUser: {
          ...prevState.newUser,
          [name]: value
        }
      }),
      () => console.log(this.state.newUser)
    );
  }

  //
  handleCheckBox(event) {
    //let name = event.target.name;

    this.setState(prevState => ({
      newUser: { ...prevState.newUser, html_mail: !this.state.newUser.html_mail }
    }));
  }

  //
  handleFormCheck(event) {
    event.preventDefault();
    this.setState({display: 'checlist'});
  }

  //
  backToForm(event) {
    this.setState({display: 'questions'});
    this.setState({isVerified: false});
  }

  //
  recaptchaLoaded() {
    console.log('loaded');
    //const recaptchaValue = recaptchaRef.current.getValue();
    this.setState({isVerified: true});
  }

  //
  handleFormSubmit(event) {
    console.log(this.state.newUser);
    event.preventDefault();
    console.log('isVerified:', this.state.isVerified);
    if(this.state.isVerified) {
      let userData = this.state.newUser;
      
      fetch('https://ayz09zrtd0.execute-api.ap-northeast-1.amazonaws.com/v1/psmwebservice', {
        method: 'POST',
        body: JSON.stringify(userData),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }})
      .then(response => {
        response.json().then(data => {
          console.log('Successful:', data);
          this.setState({display: 'finish'});
        });
      })
    } else {
      alert('Verified: false');
    }
  }

  render() {
    // console.log(this.state.newUser)
    switch(this.state.display) {
      case 'questions':

        return (
        <div>
          <Topic
            options = {this.state.display}
          />
          <form className='simple-form' onSubmit={this.handleFormCheck}>
            <InputList
              title={'お名前'}
              badge = {true}
              name = {'name_kanji'}
              options = {this.state.newUser.name_kanji}
              handleChange = {this.handleInputList}
              value = {this.state.newUser.name_kanji}
            />
            <InputList
              title={'フリガナ'}
              badge = {true}
              name = {'name_kana'}
              options = {this.state.newUser.name_kana}
              handleChange = {this.handleInputList}
              value = {this.state.newUser.name_kana}
            />
            <Select 
              title={'連絡先の選択'}
              badge = {true}
              name={'contact'}
              options = {contactOptions} 
              value = {this.state.newUser.contact}
              handleChange = {this.handleInput}
            />
            <TelephonNumber 
              title={'電話番号'}
              badge = {true}
              name = {'tel'}
              value={this.state.newUser.tel}
              handleChange={this.handleInput}
            />
            <SelectList
              title={'生年月日'}
              badge = {true}
              name={'birthday'}
              options = {this.state.birthdayOptions} 
              value = {this.state.newUser.birthday}
              itemsName = {['年 ','月 ','日 ']}
              handleChange = {this.handleInputList}
            />
            <Input
              title={'郵便番号'}
              badge = {true}
              name={'zip'}
              value = {this.state.newUser.zip} 
              placeholder = {''}
              handleChange = {this.handleAdressByZip}
            />
            <InputList
              title={'住所'}
              badge = {true}
              name = {'addres'}
              options = {this.state.newUser.addres}
              handleChange = {this.handleInputList}
              value = {this.state.newUser.addres}
            />
            <Input 
              title={'メールアドレス'}
              badge = {true}
              name = {'mail'}
              value = {this.state.newUser.mail} 
              placeholder = {''}
              handleChange = {this.handleInput}
            />
            <CheckBox 
              title={'HTMLメール不可'}
              selectedOption = {this.state.newUser.html_mail}
              handleChange = {this.handleCheckBox}
            />
            <Select 
              title={'性別'}
              badge = {true}
              name={'sex'}
              options = {['選択してください', '男性','女性']} 
              value = {this.state.newUser.sex}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'ご希望の地域1'}
              badge = {true}
              name={'area_0'}
              options = {areaOptions} 
              value = {this.state.newUser.area_0}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'ご希望の地域2'}
              name={'area_1'}
              options = {areaOptions} 
              value = {this.state.newUser.area_1}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'ご希望の地域3'}
              name={'area_2'}
              options = {areaOptions} 
              value = {this.state.newUser.area_2}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'現在のお住まい'}
              badge = {true}
              name={'current_type'}
              options = {typeOptions}
              value = {this.state.newUser.current_type}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'ご検討理由'}
              badge = {true}
              name={'reason'}
              options = {reasonOptions} 
              value = {this.state.newUser.reason}
              handleChange = {this.handleInput}
            />
            <Input 
              title={'ご入居予定人数'}
              badge = {true}
              name = {'members'}
              value = {this.state.newUser.members} 
              placeholder = {''}
              handleChange = {this.handleInput}
            />
            <RadioList
              title={'駐車場必要台数'}
              badge = {true}
              type = {'radio'}
              name = {'parking'}
              options = {parkingOptions}
              handleChange = {this.handleInput}
              value = {this.state.newUser.parking}
            />
            <Select 
              title={'ご購入予定時期'}
              name={'time_limit'}
              options = {timeOptions} 
              value = {this.state.newUser.time_limit}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'ご購入予算'}
              name={'cost'}
              options = {costOptions} 
              value = {this.state.newUser.cost}
              handleChange = {this.handleInput}
            />
            <Select 
              title={'ご希望間取り'}
              name={'floor_plan'}
              options = {planOptions} 
              value = {this.state.newUser.floor_plan}
              handleChange = {this.handleInput}
            />
            <div>＜ご確認ください＞「個人情報の取り扱いについて」はこちら</div>
            <div>「個人情報の取り扱いについて」及び
              弊社ならびにグループ企業の事業に関する情報を メール等にて受け取ることに同意される方は、
              下記「確認に進む」のボタンを押してください。</div>
            <Button
              type={'submit'} 
              name={'commit'} 
              title={'確認に進む'} 
              class={'btn-primary'} 
              data-disable-with={'確認に進む'}
            /> { /*Submit */ }
          </form>
        </div>
        );

      case 'checlist':
        return (
        <div>
          <Topic
            options = {this.state.display}
          />
          <CheckList newUser={this.state.newUser}/>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Le5GccZAAAAADebTPK1LVAKJs1ul0dye7k2fMSV"
            onChange={this.recaptchaLoaded}
          />
          <Button type={'button'} title={'OK'} class={'btn-submit'} action={this.handleFormSubmit} />
          <Button title={'戻る'} class={'btn-back'} action={this.backToForm}/>
        </div>
        );

      case 'finish':

        break;

      default:
          console.log('WHAT?...')
    };
  }
}

export default FormContainer;
